// extracted by mini-css-extract-plugin
export default {"container":"Header_container__r4cId","head":"Header_head__qOYNW","info":"Header_info__mJae6","heading":"Header_heading__BIeCZ","right":"Header_right__7yOn4"};